import { defineMessages } from 'react-intl'

const scope = 'procurify.core.components.FormattedRelativeTime'

export default defineMessages({
  justNow: {
    id: `${scope}.justNow`,
    defaultMessage: 'just now',
  },
  minutesAgo: {
    id: `${scope}.minutesAgo`,
    defaultMessage: '{count, plural, one {# minute ago} other {# minutes ago}}',
  },
  hoursAgo: {
    id: `${scope}.hoursAgo`,
    defaultMessage: '{count, plural, one {# hour ago} other {# hours ago}}',
  },
  daysAgo: {
    id: `${scope}.daysAgo`,
    defaultMessage: '{count, plural, one {# day ago} other {# days ago}}',
  },
})
